import React, { useState, useEffect } from "react";
import { BaseButtons, TabButtonFlatButton } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import useWindowDimensions from "../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { TaskManager } from "./components";

const TasksDisplay = ({
  setLoading,
  setPopUpTitle,
  setMessage,
  setToastPop,
  companyInformation,
  auth,
}) => {
  const { width, height } = useWindowDimensions();
  const [tableDisplay, setTableDisplay] = useState("Requested");
  const [tasksArray, setTasksArray] = useState(null);

  const [tasksArrayRefresh, setTasksArrayRefresh] = useState(false);

  const [selectedTask, setSelectedTask] = useState(null);

  const [filterTaskTab, setFilterTaskTab] = useState("Approved");

  const getAgencyTasks = async () => {
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/task/getAgencyTaskData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            agencyId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setTasksArray(respnseData.taskData);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to find customers, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
    }
  };
  // const AprroveTheTask = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://driverfrienddatabase-h2aa.onrender.com" + "/task/getAgencyTaskData",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           // Authorization: `bearer ${token}`,
  //         },
  //         body: JSON.stringify({
  //           agencyId: companyInformation._id,
  //         }),
  //       }
  //     );

  //     const respnseData = await response.json();

  //     if (respnseData.success) {
  //       setTasksArray(respnseData.taskData);

  //       // setToastPop(true);
  //       // setPopUpTitle("SUCCESS");
  //       // setMessage("Log-in successful");
  //       setLoading(false);

  //       // setToastPop(true);
  //     } else {
  //       setLoading(false);
  //       setPopUpTitle("FAILED");
  //       setMessage("Unable to find customers, " + " " + respnseData.message);
  //       setToastPop(true);
  //     }
  //   } catch (err) {
  //     console.log("error", err);
  //     setLoading(false);
  //     setMessage(
  //       "Unable to login into account, please wait 5 mins then try again or contact support" +
  //         " " +
  //         err
  //     );
  //     setToastPop(true);
  //     console.log("error", err);
  //   }
  // };

  useEffect(() => {
    getAgencyTasks();
  }, [companyInformation, tasksArrayRefresh]);
  return (
    <div
      style={{
        flex: 1,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      {selectedTask ? null : (
        <div style={{ position: "fixed", top: 25, display: "flex" }}>
          <div style={{ marginLeft: 10 }}>
            <TabButtonFlatButton
              title={"LISCENSING"}
              backgroundColor={
                tableDisplay === "Liscensing"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "Liscensing"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("Liscensing")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"FINES"}
              backgroundColor={
                tableDisplay === "Fines"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "Fines"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("Fines")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"VALUATION"}
              backgroundColor={
                tableDisplay === "valuation"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "valuation"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("valuation")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"SALES"}
              backgroundColor={
                tableDisplay === "sales"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "sales"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("sales")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"ENATIS"}
              backgroundColor={
                tableDisplay === "enatis"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "enatis"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("enatis")}
            />
          </div>
          <div style={{ marginLeft: 5 }}>
            <TabButtonFlatButton
              title={"REQUESTS"}
              backgroundColor={
                tableDisplay === "Requested"
                  ? colors.secondaryGrey
                  : colors.secondaryDarkBlue
              }
              textColor={
                tableDisplay === "Requested"
                  ? colors.secondaryDarkBlue
                  : colors.white
              }
              onClick={() => setTableDisplay("Requested")}
            />
          </div>
        </div>
      )}
      {tableDisplay === "Requested" ? null : (
        <div
          style={{
            minHeight: 40,
            backgroundColor: colors.secondaryGrey,
            display: "flex",
            alignItems: "center",
            color: colors.white,
            fontWeight: "bold",
          }}
        >
          <div style={{ flex: 1 }} />
          <BaseButtons
            label={"APPROVED"}
            height={"100%"}
            width={120}
            color={filterTaskTab === "Approved" ? colors.white : "#000000"}
            backgroundColor={
              filterTaskTab === "Approved"
                ? colors.secondaryDarkBlue
                : colors.secondaryGrey
            }
            onClick={() => setFilterTaskTab("Approved")}
          />
          <BaseButtons
            label={"PAID"}
            height={"100%"}
            width={120}
            color={filterTaskTab === "Paid" ? colors.white : "#000000"}
            backgroundColor={
              filterTaskTab === "Paid"
                ? colors.secondaryDarkBlue
                : colors.secondaryGrey
            }
            onClick={() => setFilterTaskTab("Paid")}
          />

          <BaseButtons
            label={"PAYMENT REQUESTED"}
            color={
              filterTaskTab === "Payment Request" ? colors.white : "#000000"
            }
            height={"100%"}
            width={180}
            backgroundColor={
              filterTaskTab === "Payment Request"
                ? colors.secondaryDarkBlue
                : colors.secondaryGrey
            }
            onClick={() => setFilterTaskTab("Payment Request")}
          />
          {/* <BaseButtons
          label={"COMPLETE"}
          color={filterTaskTab === "complete" ? colors.white : "#000000"}
          height={"100%"}
          width={140}
          backgroundColor={
            filterTaskTab === "complete"
              ? colors.secondaryDarkBlue
              : colors.secondaryGrey
          }
          onClick={() => setFilterTaskTab("complete")}
        /> */}
        </div>
      )}
      <div
        style={{
          minHeight: 40,
          backgroundColor: colors.secondaryDarkBlue,
          display: "flex",
          alignItems: "center",
          color: colors.white,
          fontWeight: "bold",
        }}
      >
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: 13,
          }}
        >
          <div style={{ marginLeft: 15, width: "100%" }}>TASK TYPE</div>
        </div>
        <div style={{ flex: 0.2, fontSize: 13 }}>STATUS</div>
        <div style={{ flex: 0.2, fontSize: 13 }}>DETAILS</div>
        <div style={{ flex: 0.2, fontSize: 13 }}>INDENTIFIER</div>
        <div
          style={{
            flex: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: 13,
          }}
        >
          ACTIONS
        </div>
      </div>
      <div
        style={{
          width: "100%",

          height: "95%",
          overflowY: "scroll",
          overflowX: "hidden",
          maxHeight: height - 150,
          scrollbarWidth: "thin",
        }}
      >
        {tableDisplay === "Requested" && tasksArray
          ? tasksArray.map((item, index) => {
              return item.taskStatus === "Requested" ? (
                <div
                  key={index}
                  onClick={() => setSelectedTask(item)}
                  style={{
                    width: "100%",
                    minHeight: 50,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: colors.white,
                  }}
                >
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 15, width: "100%" }}>
                      {item.taskTitle}
                    </div>
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskStatus}</div>
                  <div style={{ flex: 0.2, textAlign: "left", fontSize: 12 }}>
                    {item.taskDetails}
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskIdentifier}</div>
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 50,
                    }}
                  >
                    <BaseButtons
                      label={"VIEW"}
                      width={"100%"}
                      backgroundColor={colors.primaryBlue}
                      height={50}
                    />
                  </div>
                </div>
              ) : null;
            })
          : null}

        {tableDisplay === "Liscensing" && tasksArray
          ? tasksArray.map((item, index) => {
              return item.taskType === "liscense" &&
                item.taskStatus === filterTaskTab ? (
                <div
                  key={index}
                  onClick={() => setSelectedTask(item)}
                  style={{
                    width: "100%",
                    minHeight: 50,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: colors.white,
                  }}
                >
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 15, width: "100%" }}>
                      {item.taskTitle}
                    </div>
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskStatus}</div>
                  <div style={{ flex: 0.2, textAlign: "left", fontSize: 12 }}>
                    {item.taskDetails}
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskIdentifier}</div>
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 50,
                    }}
                  >
                    <BaseButtons
                      label={"VIEW"}
                      width={"100%"}
                      backgroundColor={colors.primaryBlue}
                      height={50}
                    />
                  </div>
                </div>
              ) : null;
            })
          : null}
        {tableDisplay === "sales" && tasksArray
          ? tasksArray.map((item, index) => {
              return item.taskType === "Vehicle for sale" &&
                item.taskStatus === filterTaskTab ? (
                <div
                  key={index}
                  onClick={() => setSelectedTask(item)}
                  style={{
                    width: "100%",
                    minHeight: 50,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: colors.white,
                  }}
                >
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 15, width: "100%" }}>
                      {item.taskTitle}
                    </div>
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskStatus}</div>
                  <div style={{ flex: 0.2, textAlign: "left", fontSize: 12 }}>
                    {item.taskDetails}
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskIdentifier}</div>
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 50,
                    }}
                  >
                    <BaseButtons
                      label={"VIEW"}
                      width={"100%"}
                      backgroundColor={colors.primaryBlue}
                      height={50}
                    />
                  </div>
                </div>
              ) : null;
            })
          : null}
        {tableDisplay === "valuation" && tasksArray
          ? tasksArray.map((item, index) => {
              return item.taskType === "Vehicle valuation" &&
                item.taskStatus === filterTaskTab ? (
                <div
                  key={index}
                  onClick={() => setSelectedTask(item)}
                  style={{
                    width: "100%",
                    minHeight: 50,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: colors.white,
                  }}
                >
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 15, width: "100%" }}>
                      {item.taskTitle}
                    </div>
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskStatus}</div>
                  <div style={{ flex: 0.2, textAlign: "left", fontSize: 12 }}>
                    {item.taskDetails}
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskIdentifier}</div>
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 50,
                    }}
                  >
                    <BaseButtons
                      label={"VIEW"}
                      width={"100%"}
                      backgroundColor={colors.primaryBlue}
                      height={50}
                    />
                  </div>
                </div>
              ) : null;
            })
          : null}
        {tableDisplay === "Fines" && tasksArray
          ? tasksArray.map((item, index) => {
              return item.taskType === "Fine" &&
                item.taskStatus === filterTaskTab ? (
                // &&
                //   item.taskStatus === "Approved"
                <div
                  key={index}
                  onClick={() => setSelectedTask(item)}
                  style={{
                    width: "100%",
                    minHeight: 50,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: colors.white,
                  }}
                >
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 15, width: "100%" }}>
                      {item.taskTitle}
                    </div>
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskStatus}</div>
                  <div style={{ flex: 0.2, textAlign: "left", fontSize: 12 }}>
                    {item.taskDetails}
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskIdentifier}</div>
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 50,
                    }}
                  >
                    <BaseButtons
                      label={"VIEW"}
                      width={"100%"}
                      backgroundColor={colors.primaryBlue}
                      height={50}
                    />
                  </div>
                </div>
              ) : null;
            })
          : null}

        {tableDisplay === "enatis" && tasksArray
          ? tasksArray.map((item, index) => {
              return item.taskType === "Enatis" &&
                item.taskStatus === filterTaskTab ? (
                // &&
                //   item.taskStatus === "Approved"
                <div
                  key={index}
                  onClick={() => setSelectedTask(item)}
                  style={{
                    width: "100%",
                    minHeight: 50,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: colors.white,
                  }}
                >
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ marginLeft: 15, width: "100%" }}>
                      {item.taskTitle}
                    </div>
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskStatus}</div>
                  <div style={{ flex: 0.2, textAlign: "left", fontSize: 12 }}>
                    {item.taskDetails}
                  </div>
                  <div style={{ flex: 0.2 }}>{item.taskIdentifier}</div>
                  <div
                    style={{
                      flex: 0.2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 50,
                    }}
                  >
                    <BaseButtons
                      label={"VIEW"}
                      width={"100%"}
                      backgroundColor={colors.primaryBlue}
                      height={50}
                    />
                  </div>
                </div>
              ) : null;
            })
          : null}
      </div>

      <TaskManager
        display={selectedTask}
        setSelectedTask={setSelectedTask}
        onCloseClick={() => setSelectedTask(null)}
        setMessage={setMessage}
        setToastPop={setToastPop}
        setPopUpTitle={setPopUpTitle}
        auth={auth}
        companyInformation={companyInformation}
        setTasksArrayRefresh={setTasksArrayRefresh}
        tasksArrayRefresh={tasksArrayRefresh}
      />
    </div>
  );
};
export default TasksDisplay;
